import { SearchResult } from '../types';
import {
  InitialBody,
  InitialResultDto,
  PagingBody,
  ParamsMap,
  SearchEntityType,
} from './search-v3-types';

import fetch from 'utils/fetch';

const getParamsFilters = (
  pm: ParamsMap,
  cpm: ParamsMap,
  key: SearchEntityType
) => {
  if (!pm[key]) return undefined;
  if ((pm[key]?.length ?? 0) > 0) return pm[key];
  if (cpm[key] && (cpm[key]?.length ?? 0) > 0) return [];
  return [];
};

export const searchv3Initial = async ({
  paramsMap,
  cascadingParamsMap,
}: {
  paramsMap: ParamsMap;
  cascadingParamsMap: ParamsMap;
}) => {
  const paramsMapSanitized = {} as ParamsMap;
  const cascadingParamsMapSanitized = {} as ParamsMap;
  Object.keys(paramsMap).forEach((key) => {
    const k = key as SearchEntityType;
    const filters = getParamsFilters(paramsMap, cascadingParamsMap, k);
    if (filters) {
      paramsMapSanitized[k] = filters;
    }
  });

  // Object.keys(cascadingParamsMap).forEach((key) => {
  //   const k = key as SearchEntityType;
  //   if ((cascadingParamsMap?.[k]?.length ?? 0) > 0) {
  //     cascadingParamsMapSanitized[k] = cascadingParamsMap[k];
  //   }
  // });

  Object.keys(cascadingParamsMap).forEach((key) => {
    const k = key as SearchEntityType;
    if (cascadingParamsMap?.[k] !== undefined) {
      cascadingParamsMapSanitized[k] = cascadingParamsMap[k];
    }
  });

  const body: InitialBody = {
    paramsMap: paramsMapSanitized,
    cascadingParamsMap: cascadingParamsMapSanitized,
  };

  const response = await fetch('/api/search/v3/initial', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });

  return (await response.json()) as InitialResultDto;
};

export const searchV3Paging = async ({
  paramsMap,
  archivalCollectionIds,
  archivalAidIds,
  selectedEntityType,
  size,
  offset,
}: {
  paramsMap: ParamsMap;
  archivalCollectionIds?: string[];
  archivalAidIds?: string[];
  selectedEntityType: SearchEntityType;
  size: number;
  offset: number;
}) => {
  const body: PagingBody = {
    selectedEntityType,
    archivalCollectionIds,
    archivalAidIds,
    params: {
      size,
      offset,
      filters: paramsMap[selectedEntityType],
    },
  };

  const response = await fetch('/api/search/v3/paging', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });

  return (await response.json()) as SearchResult;
};
